// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  feedKey: __t.string().primaryKey().name("feed_key"),
  owner: __t.identity(),
  serial: __t.string(),
  itemKey: __t.string().name("item_key"),
  rounds: __t.u32(),
  charge: __t.f32(),
  chargeAt: __t.timestamp().name("charge_at"),
  reloadUntil: __t.timestamp().name("reload_until"),
  updatedAt: __t.timestamp().name("updated_at"),
});
